import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AfterViewInit, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../services/common.service';
import { Route, Router } from '@angular/router';
import { ConfirmationDialogueComponent } from '../../modal/confirmation-dialogue/confirmation-dialogue.component';
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from '@angular/cdk/layout';
import { Subject, Observable, Subscription, map } from 'rxjs';
import { ClubServicesService } from '../../services/club-services.service';
import { PlayerServicesService } from '../../services/players-services.service';
import { RestaurantService } from '../../services/restaurant-services.';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { filter } from 'rxjs/operators';
import $ from 'jquery';

@Component({
  selector: 'app-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['../../../../styles.scss', './dashboard-header.component.scss'],
})
export class DashboardHeaderComponent implements OnInit {

  isActive = false;
  isCollapsed = true;
  svgContent: any;
  username: string = '';
  currentUser: any = localStorage.getItem("currentUser");
  ProfileDetails: any;
  NotificationsList: any = [];
  unreadNotifications: any = [];
  hasBackdrop: boolean;
  sidenaveOpen: any;
  t: any;
  @ViewChild('drawer') drawer: any;
  @ViewChild('NotMenu') NotMenu: MatMenuTrigger;

  public selectedItem: string = '';
  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result: BreakpointState) => result.matches));


  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private csobj: CommonService,
    private router: Router,
    private dialogue: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private clubsService: ClubServicesService,
    private playersService: PlayerServicesService,
    private restoService: RestaurantService,
    private spinner: SpinnerVisibilityService
  ) { }

  ngOnInit(): void {
    const route = this.router.url;
    if (route.includes('/restaurant_dash/upcoming_orders')) {
      this.activeTabIndex = 0;
    } else if (route.includes('/organization_dash') || route.includes('/team_dash')) {
      this.activeTabIndex = 1;
    } else if (route.includes('/manage_Orders')) {
      this.activeTabIndex = 2;
    }
    this.loadSVG();
    this.getProfileDetails();
    this.currentUser = JSON.parse(this.currentUser);
    this.currentUser = this.currentUser?.userDetails?.userType ? this.currentUser?.userDetails?.userType : this.currentUser?.userType;
    console.log(this.currentUser, "currentUser");
    // this.username = JSON.parse(this.currentUser)

    this.csobj.profile$.subscribe((res: any) => {
      this.getProfileDetails();
    })

    // aria-expanded=true

    if (this.currentUser == 3) {
      this.getPlayerNotifications();
    } else if (this.currentUser == 2) {
      this.getClubNotifications();
    } else {
      this.getRestroNotifications();
    }

    let y = setInterval(() => {

      let user = localStorage.getItem("currentUser");

      let currentUser = JSON.parse(user);
      currentUser = currentUser?.userDetails?.userType ? currentUser?.userDetails?.userType : currentUser?.userType;

      if (currentUser) {
        let notifi = (<HTMLInputElement>document.querySelector('#bellIcon'));
        let attribute = notifi?.getAttribute('aria-expanded');

        let notifiMobile = (<HTMLInputElement>document.querySelector('.bell-mobile'));
        let attributeMobile = notifiMobile?.getAttribute('aria-expanded');


        let sidnave = (<HTMLInputElement>document.querySelector('#offcanvas1'));
        this.sidenaveOpen = sidnave?.getAttribute('aria-modal');

        if (attribute || attributeMobile) {
          this.readNotification(1, 1);
        }
      } else {
        clearInterval(y);
      }

    }, 1000)


    let x = setInterval(() => {
      let user = localStorage.getItem("currentUser");

      let currentUser = JSON.parse(user);
      currentUser = currentUser?.userDetails?.userType ? currentUser?.userDetails?.userType : currentUser?.userType;

      if (currentUser) {
        if (this.currentUser == 3) {
          this.getPlayerNotifications();
        } else if (this.currentUser == 2) {
          this.getClubNotifications();
        } else {
          this.getRestroNotifications();
        }
      }
      else {
        clearInterval(x)
      }
      if (!currentUser) {
        clearInterval(x);
      }


    }, 10000)

    //close sidnav mobile on click body
    $(document).on('click', (event) => {
      if (this.sidenaveOpen) {
        if (!$(event.target).closest('#offcanvas1').length) {
          document?.getElementById('closeSidnameMob')?.click();
        }
      }
    });
  }

  closeSideNav() {
    if (this.drawer._mode == 'over') {
      this.drawer.close();
    }
  }
  activeTabIndex: number = 0; // default no tab active




  loadSVG() {
    this.http.get('../../../../../assets/SVG/logo.svg', { responseType: 'text' })
      .subscribe(svgData => {
        this.svgContent = this.sanitizer.bypassSecurityTrustHtml(svgData);
      });
  }
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  toggleActive(tabIndex: number) {
    this.activeTabIndex = tabIndex;


    if (tabIndex == 2) {
      this.router.navigateByUrl('/manage_Orders');
    } else if (this.currentUser == 2) {
      this.router.navigateByUrl('/organization_dash');
    } else if (this.currentUser == 3) {
      this.router.navigateByUrl('/team_dash');
    } else {
      this.router.navigateByUrl('/restaurant_dash/upcoming_orders');
    }
  }

  onClickLogo() {
    this.isActive = !this.isActive;
    if (this.currentUser == 2) {
      this.router.navigateByUrl('/organization_dash');
      let url = this.router.url;
      if (url == '/organization_dash') {
        location.reload();
      }

    } else if (this.currentUser == 3) {
      this.router.navigateByUrl('/team_dash');
      let url = this.router.url;
      if (url == '/team_dash') {
        location.reload();
      }
    } else {
      this.router.navigateByUrl('/restaurant_dash/upcoming_orders');
      let url = this.router.url;
      if (url == '/restaurant_dash/upcoming_orders') {
        location.reload();
      }
    }
  }

  logoutClick() {
    const dialogRef = this.dialogue.open(ConfirmationDialogueComponent, {

      hasBackdrop: true,
      disableClose: true,
      width: '469px',

      data: {
        userType: {
          titleOne: 'Are you sure you want to Logout?',
          text: "",
          imgPath: '../../../../assets/icon/logout.png',
          access: "logout",
          id: '',
        }
      },
    });


  }

  getProfileDetails() {
    try {
      this.csobj.getProfile().subscribe((res: any) => {
        this.ProfileDetails = res;
        if (this.ProfileDetails.output.userData.userType == 2) {
          this.username = res?.output?.userData?.contactName
        } else {
          if (res.output.userData.firstName != undefined) {
            this.username = res?.output?.userData?.firstName
          }
          else if (res.output.userData.firstName == undefined) {
            this.username = res?.output?.userData?.restaurantName
          }
        }
      })
    }
    catch (e) { }
  }

  editProfileClick() {
    console.log(this.ProfileDetails.output.userData.userType);
    if (this.ProfileDetails.output.userData.userType == 2) {
      this.router.navigate(['/organization_edit_profile'])
    } else if (this.ProfileDetails.output.userData.userType == 3) {
      this.router.navigate(['/team_edit_profile'])
    }
    else if (this.ProfileDetails.output.userData.userType == 4) {
      this.router.navigate(['/restaurant_edit_profile'])
    }

  }

  changesPasswordClick() {
    this.router.navigate(['changesPassword'])
  }

  contactusClick() {
    this.router.navigate(['contactus'])
  }

  playPromoCode() {
    this.router.navigate(['/playPromoCodes'])
  }

  manageOrders() {
    if (this.ProfileDetails.output.userData.userType == 2) {
      console.log(this.ProfileDetails.output.userData.userType);
      this.router.navigate(['/manageOrders'])
    } else if (this.ProfileDetails.output.userData.userType == 3) {
      this.router.navigate(['/manageOrders'])
    }
    else if (this.ProfileDetails.output.userData.userType == 4) {
      this.router.navigate(['/manageOrders'])
    }



  }

  favouriteOrders() {
    if (this.ProfileDetails.output.userData.userType == 2) {
      this.router.navigate(['/favouriteOrders'])
    } else if (this.ProfileDetails.output.userData.userType == 3) {
      this.router.navigate(['/favouriteOrders'])
    }
    else if (this.ProfileDetails.output.userData.userType == 4) {
      this.router.navigate(['/favouriteOrders'])
    }

    this.router.navigateByUrl('/favouriteOrders', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/favouriteOrders'])
    });

  }

  cardDetails() {
    this.router.navigate(['cardDetails'])

  }

  onEventButtonClick(): void {

    if (this.currentUser == 2) {
      this.router.navigateByUrl('/organization_dash');
    } else if (this.currentUser == 3) {
      this.router.navigateByUrl('/team_dash');
    }
  }



  manageEventClick() {
    let current_route = this.router.url
    this.router.navigateByUrl(current_route, { skipLocationChange: true }).then(() => {
      this.router.navigate(["/manageEvents"])
      window.location.reload();
    });
  }

  manageTeamstClick() {
    this.router.navigateByUrl("/manageTeams", { skipLocationChange: true }).then(() => {
      // this.router.navigate(["/manageTeams"])
      window.location.href = "/manageTeams";
    });
  }


  getClubNotifications() {
    this.spinner.show();
    this.clubsService.getClubNotification().subscribe((res: any) => {
      if (res.status == 200) {
        this.setNotifications(res);
        // this.NotificationsList = res.output;
        // this.unreadNotifications = [];
        // for(var i of this.NotificationsList){
        //   if(i?.isRead==false){
        //     this.unreadNotifications.push(i);
        //   }
        // }
      }
    })
    this.spinner.hide();
  }

  getPlayerNotifications() {
    this.spinner.show();
    this.playersService.getPlayerNotification().subscribe((res: any) => {
      if (res.status == 200) {
        this.setNotifications(res);
      }
    })
    this.spinner.hide();
  }

  getRestroNotifications() {
    this.spinner.show();
    this.restoService.getRestaurantNotification().subscribe((res: any) => {
      if (res.status == 200) {
        this.setNotifications(res);
      }
    })
    this.spinner.hide();
  }

  setNotifications(res) {
    this.NotificationsList = res.output;
    this.unreadNotifications = [];
    for (var i of this.NotificationsList) {
      if (i?.isRead == false) {
        this.unreadNotifications.push(i);
      }
    }
  }

  calculateTime(previousDate) {
    let currentDate = new Date().getTime();
    let previous = new Date(previousDate).getTime();
    let miliseconds = currentDate - previous
    var days: any = Math.floor(miliseconds / (1000 * 60 * 60 * 24));
    var hours: any = Math.floor((miliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes: any = Math.floor((miliseconds % (1000 * 60 * 60)) / (1000 * 60));
    var seconds: any = Math.floor((miliseconds % (1000 * 60)) / 1000);
    if (days) {
      return `${days} Days ago`;
    } else if (hours) {
      return `${hours} hr ago`;
    } else if (minutes) {
      if (minutes <= 1) {
        return `${minutes} Minute ago`;
      } else {
        return `${minutes} Minutes ago`;
      }

    } else {
      return `Now`;
    }
  }

  readNotification(data: any, index: any) {
    this.spinner.show();
    let unreadData: any = [];
    for (var i of this.NotificationsList) {
      if (i?.isRead == false) {
        unreadData.push(i?._id);
        i.isRead = true;
      }
    }
    if (unreadData.length <= 0) {
      this.spinner.hide();
      return
    }
    this.unreadNotifications = [];
    this.csobj.updateMultiNotification({ id: unreadData }).subscribe((res: any) => {
      if (res.status == 200) {

      }
    })
    this.spinner.hide();
  }


  ngAfterViewInit() {
    // Inject our custom logic of menu close
    (this.NotMenu as any).closed = this.configureMenuClose(this.NotMenu.menuClosed);
  }

  private configureMenuClose(old: MatMenu['closed']): MatMenu['closed'] {
    const upd = new EventEmitter();
    feed(upd.pipe(
      filter(event => {
        console.log(`menu.close(${JSON.stringify(event)})`);
        if (event === 'click') {
          // Ignore clicks inside the menu
          return false;
        }
        return true;
      }),
    ), old);
    return upd;
  }

}

function feed<T>(from: Observable<T>, to: Subject<T>): Subscription {
  return from.subscribe(
    data => to?.next(data),
    err => to?.error(err),
    () => to?.complete(),
  );
}



